import { getTestId } from '@airtel/air-design-system';
export var defaultProps = Object.assign({
  offerTitle: 'congratulations',
  title: 'Yay, offer applied!',
  subTitle: "You've saved",
  imageUrl: 'https://assets.airtel.in/static-assets/airtel-pay-sdk/offers/xxhdpi/congratulations.png',
  offerHeading: '₹500 off',
  offerSubHeading: 'on your HD box',
  ctaText: 'GOT IT',
  accessibilityProps: {
    accessibilityRole: 'alert'
  },
  onCtaPressMetaData: {
    id: 'on cta press'
  }
}, getTestId('OfferPopupWidgetContainer'));